var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#312F3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C18.208 32 20 30.208 20 28V24H16C13.792 24 12 25.792 12 28C12 30.208 13.792 32 16 32Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C12 17.792 13.792 16 16 16H20V24H16C13.792 24 12 22.208 12 20Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12 9.792 13.792 8 16 8H20V16H16C13.792 16 12 14.208 12 12Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H24C26.208 8 28 9.792 28 12C28 14.208 26.208 16 24 16H20V8Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20C28 22.208 26.208 24 24 24C21.792 24 20 22.208 20 20C20 17.792 21.792 16 24 16C26.208 16 28 17.792 28 20Z",
    fill: "#1ABCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFigma);
export default __webpack_public_path__ + "static/media/icon-figma.178c1e2a15eb882ae526ab24cd02f0de.svg";
export { ForwardRef as ReactComponent };